export default __webpack_public_path__ + "static/media/walkthrough-close.133884f4.svg";